<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Aktarılan Faturalar</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
              <div class="row col-lg-12">
                <form
                  class="m-form m-form--fit m-form--label-align-right col-lg-12"
                >
                  <div class="m-portlet__body">
                    <div class="form-group m-form__group row">
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Başlangıç Tarihi."
                          v-model="seachModel.startCreatedDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Bitiş Tarihi."
                          v-model="seachModel.endCreatedDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-4">
                        <input
                          type="text"
                          v-model="seachModel.invoiceNumber"
                          class="form-control m-input"
                          placeholder="Fatura Numarası."
                        />
                      </div>
                    </div>
                    <div class="form-group m-form__group row">
                      <div class="col-lg-4">
                        <input
                          type="text"
                          v-model="seachModel.uuId"
                          class="form-control m-input"
                          placeholder="UuId."
                        />
                      </div>
                      <div class="col-lg-4">
                        <select
                          class="form-control m-input"
                          placeholder="Durum."
                          v-model="seachModel.operationStatus"
                        >
                          <option :value="null">Durum.</option>
                          <option
                            v-for="option in status"
                            v-bind:value="option.id"
                            v-bind:key="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <select
                          class="form-control m-input"
                          placeholder="Durum."
                          v-model="seachModel.documentType"
                        >
                          <option :value="null">Tip.</option>
                          <option
                            v-for="option in documentTypes"
                            v-bind:value="option.id"
                            v-bind:key="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                   <div class="form-group m-form__group row">
                        <div class="col-lg-4">
                        <input
                          type="text"
                          v-model="seachModel.fileName"
                          class="form-control m-input"
                          placeholder="Dosya Adı."
                        />
                      </div>
                      <div class="col-lg-1" style="margin-top:10px;">
                          <label>Excel'e Aktar</label>
                      </div>
                      <div class="col-lg-1">
                        <input
                          type="checkbox"
                          style="height:30px;margin-top:10px;"
                          v-model="seachModel.isExport"
                          class="form-control m-input checkbox checked"
                          placeholder="Excel."
                        />
                      </div>
                    </div>
                    <div class="form-group m-form__group row">
                      <div class="col-lg-1">
                        <button
                          type="button"
                          @click="search()"
                          class="spbtn"
                        >
                          Ara
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!--begin: Datatable -->
              <div
                id="m_table_1_wrapper"
                class="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="
                        table
                        table-striped-
                        table-bordered
                        table-hover
                        table-checkable
                        dataTable
                        no-footer
                        dtr-inline
                      "
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            UuId
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            Numara
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Referans
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Mesaj
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Dönüş Kodu
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Durum
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Tip
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Son Güncelleme
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            İptal mi?
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Tarihce
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="model.items && model.items.length">
                        <tr
                          role="row"
                          class="odd"
                          v-for="item in model.items"
                          v-bind:key="item.id"
                        >
                          <td>{{ item.uuId }}</td>
                          <td>{{ item.number }}</td>
                          <td>{{ item.referenceId }}</td>
                          <td>
                            <div style="height: 80px; overflow: auto">
                              {{ item.message }}
                            </div>
                          </td>
                          <td>{{ item.responseCode }}</td>
                          <td>{{ item.operationStatusDescription }}</td>
                          <td>{{ item.documentTypeDescription }}</td>
                          <td>
                            {{
                              item.currentDate
                                | moment(false, "yyyy-MM-dd'T'HH:mm").format(
                                  "DD/MM/YYYY"
                                )
                            }}
                          </td>
                          <td>{{ item.isCancel }}</td>
                          <td>
                            <a
                              :href="'#/invoices/history/' + item.id"
                              class="
                                m-portlet__nav-link
                                btn
                                m-btn
                                m-btn--hover-brand
                                m-btn--icon
                                m-btn--icon-only
                                m-btn--pill
                              "
                              title="View"
                            >
                              <i class="la la-edit"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
          <div class="m-portlet m-portlet--mobile">
            <paginate
              :page-count="
                Math.ceil(this.model.totalCount / this.model.pageSize)
              "
              :click-handler="changePage"
              :prev-text="'<<'"
              :next-text="'>>'"
              :container-class="'pagination'"
              :page-class="'pageclass'"
              :next-link-class="'pageclass'"
              :prev-link-class="'pageclass'"
              :active-class="'activelink'"
            >
              >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.pagination {
  color: black;
  float: left;
  padding: 8px 8px;
  text-decoration: none;  
}

.pageclass{
   color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #ddd;
}
.activelink{
  background-color: #5aa3ff;
  border:1px;
}
</style>

<script>
import {
  _searchInvoiceRecords,
  _getOperationStatusEnumDescriptionStatus,
  _getDocumentTypeEnumDescriptionStatus,
} from "../../services/InvoiceService";
import {
  _excelExport
} from "../../services/ExportService";

import datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      model: {
        items: [],
        page: 0,
        pageSize: 0,
        totalCount: 0,
      },
      seachModel: {
        startCreatedDate: null,
        endCreatedDate: null,
        invoiceNumber: null,
        operationStatus: null,
        documentType: null,
        uuId: null,
        page: null,
        isExport:false,
        fileName:null
      },
      status: [],
      documentTypes: [],
    };
  },
  created() {
    this.getStatus();
    this.getTypes();
  },
  components: {
    datepicker: datepicker,
  },
  methods: {
    getAll: function () {
      // let loader=this.$loading.show();
      _searchInvoiceRecords(this.seachModel).then((response) => {
        this.model = response.data.data;
        if (response.data.data.isExport) {
          _excelExport(response.data.data.exportData);
        }
      });
    },
    changePage: function (page) {
      this.seachModel.page = page;
      this.getAll();
    },
    getStatus: function () {
      _getOperationStatusEnumDescriptionStatus().then((response) => {
        this.status = response.data;
      });
    },
    getTypes: function () {
      _getDocumentTypeEnumDescriptionStatus().then((response) => {
        this.documentTypes = response.data;
      });
    },
    search: function () {
      this.seachModel.page = 1;
      this.getAll(this.seachModel);
    },
  },
};
</script>